// Define chart options for the candidate pipeline growth KPI
export let followersGrowth: any = {
  series: [
    {
      name: "Recruitments delay (days)",
      data: [5, 10, 12, 8, 15, 20, 22, 24, 18, 14, 16, 25], // Example data for the pipeline growth
    },
  ],
  chart: {
    height: 135,
    type: "line",
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      enabledOnSeries: undefined,
      top: 5,
      left: 0,
      blur: 4,
      color: "#00E396", // Primary theme color
      opacity: 0.25,
    },
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  colors: ["#00E396"], // Primary color for the line
  stroke: {
    width: 4,
    curve: "smooth",
  },
  xaxis: {
    type: "category",
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    tickAmount: 10,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      gradientToColors: ["#00E396"],
      shadeIntensity: 1,
      type: "horizontal",
      opacityFrom: 0.6,
      opacityTo: 0.9,
      colorStops: [
        {
          offset: 0,
          color: "#00E396",
          opacity: 0.6,
        },
        {
          offset: 100,
          color: "#00E396",
          opacity: 0.9,
        },
      ],
    },
  },
  yaxis: {
    min: 0,
    max: 30,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          height: 300,
        },
      },
    },
    {
      breakpoint: 768,
      options: {
        chart: {
          height: 250,
        },
      },
    },
  ],
};

export let kpiByAge: any = {
  series: [
    {
      name: "Number of Candidates",
      data: [10, 20, 15, 25, 30, 18, 22, 27, 32, 28, 21, 19], // Example data for the number of candidates by age group
    },
  ],
  chart: {
    height: 135,
    type: "line",
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      enabledOnSeries: undefined,
      top: 5,
      left: 0,
      blur: 4,
      color: "#FF4560", // Updated theme color
      opacity: 0.25,
    },
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  colors: ["#FF4560"], // Updated color for the line
  stroke: {
    width: 4,
    curve: "smooth",
  },
  xaxis: {
    type: "category",
    categories: ["18-24", "25-29", "30-34", "35-39", "40-44", "45-49", "50-54", "55-59", "60-64", "65-69", "70-74", "75+"],
    tickAmount: 10,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      gradientToColors: ["#FF4560"],
      shadeIntensity: 1,
      type: "horizontal",
      opacityFrom: 0.6,
      opacityTo: 0.9,
      colorStops: [
        {
          offset: 0,
          color: "#FF4560",
          opacity: 0.6,
        },
        {
          offset: 100,
          color: "#FF4560",
          opacity: 0.9,
        },
      ],
    },
  },
  yaxis: {
    min: 0,
    max: 35,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          height: 300,
        },
      },
    },
    {
      breakpoint: 768,
      options: {
        chart: {
          height: 250,
        },
      },
    },
  ],
};


export let visitors: any = {
  series: [
    {
      name: "Hires",
      data: [30, 45, 70, 55, 40, 60], // Example data; replace with actual hire numbers
    },
    {
      name: "Applications",
      data: [80, 90, 75, 85, 70, 95], // Example data; replace with actual application numbers
    },
  ],
  chart: {
    type: "bar",
    height: 270,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 6,
    colors: ["transparent"],
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: ["#34c38f", "#556ee6"], // Example colors; replace with your theme colors
  xaxis: {
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], // Adjust categories as needed
    tickAmount: 4,
    tickPlacement: "between",
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 5,
    tickPlacement: "between",
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
    fontFamily: "Rubik, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    labels: {
      colors: "var(--chart-text-color)",
    },
    markers: {
      width: 6,
      height: 6,
      radius: 12,
    },
    itemMargin: {
      horizontal: 10,
    },
  },
  responsive: [
    {
      breakpoint: 1366,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "80%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "60%",
          },
        },
        grid: {
          padding: {
            right: 5,
          },
        },
      },
    },
  ],
};


export let averageSales: any = {
  series: [70],
  chart: {
    height: 130,
    type: "radialBar",
    dropShadow: {
      enabled: true,
      top: 3,
      left: 0,
      blur: 10,
      color: "var(--theme-deafult)",
      opacity: 0.35,
    },
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "60%",
      },
      track: {
        strokeWidth: "60%",
        opacity: 1,
        margin: 5,
      },
      dataLabels: {
        showOn: "always",
        value: {
          color: "var(--body-font-color)",
          fontSize: "14px",
          show: true,
          offsetY: -10,
        },
      },
    },
  },
  colors: ["var(--theme-deafult)"],
  stroke: {
    lineCap: "round",
  },
  responsive: [
    {
      breakpoint: 1500,
      options: {
        chart: {
          height: 130,
        },
      },
    },
  ],
  title: "Average Sales Per Day",
  sales: "45,908",
  growth: "+5.7",
  desc: "The point of using Lorem Ipsum",
};


export let averageProfit: any = {
   series: [60],
   chart: {
     height: 130,
     type: "radialBar",
     dropShadow: {
       enabled: true,
       top: 3,
       left: 0,
       blur: 10,
       color: "var(--theme-secondary)",
       opacity: 0.35,
     },
   },
   plotOptions: {
     radialBar: {
       hollow: {
         size: "60%",
       },
       track: {
         strokeWidth: "60%",
         opacity: 1,
         margin: 5,
       },
       dataLabels: {
         showOn: "always",
         value: {
           color: "var(--body-font-color)",
           fontSize: "14px",
           show: true,
           offsetY: -10,
         },
       },
     },
   },
   colors: ["var(--theme-secondary)"],
   stroke: {
     lineCap: "round",
   },
   responsive: [
     {
       breakpoint: 1500,
       options: {
         chart: {
           height: 130,
         },
       },
     },
   ],
   title: "Average Profit Per Day",
   sales: "89.6%",
   growth: "+2.7",
   desc: "The point of using Lorem Ipsum",
 };
 